// extracted by mini-css-extract-plugin
export default {"card":"zCDZPK","user":"b1kGaw","screenName":"DwgsLS","image":"RIYEUU","content":"EWwpH_","quote":"Q44Op_"};